import React, { useState } from 'react';
import { useContracts } from '../../hooks/useContracts';
import { useNotify } from '../../context/NotificationContext';
import { parseError } from '../../utils/errorParser';
import { fmtUSDT, fmtAgo } from '../../utils/format';
import ButtonLoader from '../common/ButtonLoader';

const HeldIncomeList = ({ held, onChanged }) => {
  const { plans } = useContracts();
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  const ids = held?.ids || [];
  const total = (held?.amounts || []).reduce(
    (acc, a) => acc + parseFloat(fmtUSDT(a).replace(/,/g, '')),
    0
  );

  const onClaim = async () => {
    if (!plans?.write) return notify.error('Wallet', 'Connect wallet first');
    setBusy(true);
    try {
      const tx = await plans.write.claimHeldIncome();
      notify.info('Claiming', 'Transaction submitted…');
      await tx.wait();
      notify.success('Claimed', 'Held income claimed successfully');
      onChanged && onChanged();
    } catch (e) {
      notify.error('Claim failed', parseError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card">
      <div className="card-title">Held Sponsor Income</div>
      <div className="card-sub" style={{ marginTop: 4 }}>
        Held entries unlock once you upgrade or re-topup the matching package within the hold window. Claim sends 95% to your wallet (5% fee).
      </div>

      {ids.length === 0 ? (
        <div className="empty" style={{ padding: '24px 0' }}>
          <div className="empty-icon">○</div>
          <div className="empty-title">No held income</div>
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '14px 0' }}>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700 }}>
              Total: <span style={{ color: 'var(--bnb-yellow)' }}>{total.toFixed(2)}</span> USDT
            </div>
            <button className="btn btn-primary btn-sm" onClick={onClaim} disabled={busy}>
              {busy ? <ButtonLoader label="Claiming" /> : 'Claim Eligible'}
            </button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {ids.map((id, i) => (
              <div className="held-card" key={id}>
                <div>
                  <div className="amt">{fmtUSDT(held.amounts[i])} USDT</div>
                  <div className="meta">Pkg #{held.packageIds[i]} · created {fmtAgo(held.createdAts[i])}</div>
                </div>
                <span className="badge badge-yellow">HELD</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default HeldIncomeList;
